import React from 'react';
import { Modal, LongTextInput } from 'hyperdb-utils';

export default class ReservationRemarksContainer extends React.Component {
  constructor(props) {
    super(props);
    this.api = this.props.api[this.props.type];
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  render() {
    return (
      <div>
        <div className="box box-primary">
          <div className="header-label">
            Remarks
            &nbsp; <button onClick={ this.toggleModal.bind(this, true) } className="btn btn-primary btn-sm" title="Edit customer"><i className="fas fa-edit"/></button>
          </div>
          <div className="box-body">
            {
              this.props.reservation.remarks
                ? <textarea disabled style={{width: '100%'}} value={ this.props.reservation.remarks } />
                : null
            }
          </div>
        </div>
        {
          this.props.showModalRemarks
            ? <Modal show={true} onClose={this.toggleModal.bind(this, false)} onAccept={this.handleSave}>
                <LongTextInput
                  label="Remarks"
                  name="remarks"
                  value={ this.props.editedRemarks }
                  onChange={ this.handleChange }
                />
              </Modal>
            : null
        }
      </div>
    );
  }
  toggleModal(bool) {
    const editedRemarks = this.props.reservation.remarks;
    this.api.setData({ showModalRemarks: bool, editedRemarks });
  }
  handleChange(field) {
    this.api.setData({ editedRemarks: field.value });
  }
  handleSave() {
    const remarks = this.props.editedRemarks;
    this.api.submitEditForm({ objectData: { remarks, _patch: true }, id: this.props.reservation.id });
    this.api.updateEditedObject({ attributeName: 'remarks', value: remarks });
    this.api.setData({ showModalRemarks: false });
  }
}



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ReservationRemarksContainer.jsx